import { Card as MuiCard, styled } from '@mui/material';
export const Card = styled(MuiCard)(({ theme, sx }) => ({
    borderRadius: 12,
    boxShadow: 'none',
    boxSizing: 'border-box',
    height: '100%',
    '& .MuiAvatar-root': {
        backgroundColor: theme.palette.primary.dark,
    },
    '& .MuiCardHeader-title': {
        color: theme.palette.text.secondary,
        paddingBottom: 0,
    },
    '& .MuiCardContent-root': {
        display: 'flex',
        flexDirection: 'column',
        gap: 16,
    },
    '& .MuiCardActions-root': {
        gap: 16,
        marginLeft: 8,
    },
    //@ts-ignore
    maxWidth: sx?.maxWidth ?? 480,
}));
